/**
 * Determines if touch events are supported.
 *
 * @returns {boolean} True if touch events are supported, false otherwise.
 *
 * @example
 * if (isTouchEnabled()) {
 *   console.log('This device supports touch events');
 * } else {
 *   console.log('This device does not support touch events');
 * }
 *
 */
export function isTouchEnabled(): boolean {
    return 'ontouchstart' in window;
}
